<ion-textarea
  [formControl]="formControl"
  [ionFormlyAttributes]="field"
  [cols]="props.cols"
  [rows]="props.rows"
  [placeholder]="props.placeholder"
>
</ion-textarea>
